export default "__VITE_ASSET__C7tFHR3W__"